/**
 * Form Event Handlers Component
 * Handles form submission and interaction events
 */

'use strict';

var twentyninetimesCustomForm = twentyninetimesCustomForm || {};

twentyninetimesCustomForm.FormEventHandlers = {
    /**
     * Initialize event delegation for form submit buttons
     */
    initializeSubmitHandlers: function() {
        document.body.addEventListener('click', this.handleSubmitClick.bind(this));
    },

    /**
     * Handle submit button clicks with event delegation
     * Supports both single-step and multi-step forms
     * @param {Event} e - Click event
     */
    handleSubmitClick: function(e) {
        const submitBtn = e.target.closest('.customform-submit');
        if (!submitBtn) return;
        
        const formular = submitBtn.closest('.customform-form');
        if (!formular) return;

        e.stopPropagation();

        // Get current field container (step or single)
        const currentContainer = twentyninetimesCustomForm.MultiStepNavigation.getCurrentStepContainer(formular);
        if (!currentContainer) return;

        // Validate all required fields in the container
        const validated = twentyninetimesCustomForm.FormValidator.validateContainer(currentContainer);
        
        if (validated) {
            // Try to move to next step in multi-step forms
            const movedToNextStep = twentyninetimesCustomForm.MultiStepNavigation.moveToNextStep(
                formular, 
                submitBtn, 
                currentContainer
            );

            // If this is the final step or single-step form, allow form submit
            if (!movedToNextStep) {
                submitBtn.setAttribute('type', 'submit');
            }
        }
    }
};